import { useState } from "react"
import ListHeader from "@/components/custom/ListHeader"
import { useNewsListQuery } from "@/service/api/news"
import type { ListRequest } from "@/shared/types/commonResponse"
import NewsCard from "./NewsCard"
import { STAR_ID } from "@/shared/constants/star"
import NewsListSkeleton from "@/components/skeleton/news/news-list-skeleton"

const NewsList = () => {
  const [newsList, setNewsList] = useState<ListRequest>({
    Language: "en",
    angkorId: "",
    requestDto: {
      pageable: {
        page: 0,
        size: 1000,
        sort: [],
      },
      searchKeyword: "",
      starId: STAR_ID,
    },
  })

  const { data: newsListData = { content: [] }, isLoading } =
    useNewsListQuery(newsList)

  return (
    <div>
      <ListHeader title="News" />

      <div className="px-4 pt-16">
        {isLoading ? (
          <NewsListSkeleton />
        ) : (
          newsListData.content.map((item) => (
            <NewsCard
              key={item.id}
              id={item.id}
              title={item.title}
              date={item.regDt}
              image={item.thumbImageUrl}
            />
          ))
        )}
      </div>
    </div>
  )
}

export default NewsList
